import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getSettingInternationalBuyingNudges } from "@faire/retailer-visitor-shared/settings/getSettingInternationalBuyingNudges";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import styled, { css } from "styled-components";
export var PromoIcon = function(param) {
    var icon_url = param.icon_url;
    if (icon_url) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(PromotionIcon, {
                    src: icon_url,
                    $offset: getSettingInternationalBuyingNudges() ? undefined : 2,
                    $size: getSettingInternationalBuyingNudges() ? 18 : undefined
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: "2x"
                })
            ]
        });
    }
    return null;
};
var PromotionIcon = styled.img.withConfig({
    componentId: "sc-e0fb2236-0"
})([
    "width:",
    "px;height:",
    "px;",
    ""
], function(props) {
    var _props_$size;
    return (_props_$size = props.$size) !== null && _props_$size !== void 0 ? _props_$size : 24;
}, function(props) {
    var _props_$size;
    return (_props_$size = props.$size) !== null && _props_$size !== void 0 ? _props_$size : 24;
}, function(props) {
    return props.$offset ? css([
        "position:relative;bottom:",
        "px;"
    ], props.$offset) : "";
});
